/** @typedef {import('./DOMHelpers.svc')} Types */
//
export class DOMHelpers {
	constructor($window, $log) {
		'ngInject';
		this.window = $window;
		this.log = $log;
	}

	/** @param {number} [size=480] */
	isSmallView(size = 480) {
		return this.window.document.querySelector('body').getBoundingClientRect().width < size;
	}

	/** @param {Event} e */
	targetInnerWidth(e) {
		return e?.target?.innerWidth || null;
	}

	/** @param {number|null} [top=null] */
	scrollY(top = null) {
		if (!top) throw new Error('Scroll Y value is required');
		return this.window.scrollY > top;
	}

	scrollHeight() {
		return this.window.document.querySelector('body').scrollHeight;
	}

	/** @param {string} selector */
	querySelector(selector) {
		return this.window.document.querySelector(selector);
	}

	/** @param {string} id */
	getById(id) {
		return this.window.document.getElementById(id);
	}

	/** @param {string} tagName */
	getByTag(tagName) {
		return this.window.document.getElementsByTagName(tagName);
	}

	/** @param {string} selector */
	querySelectorAll(selector) {
		return this.window.document.querySelectorAll(selector);
	}

	/** @param {string} elm */
	createElement(elm) {
		return this.window.document.createElement(elm);
	}

	/**
	 * @param {string} src
	 * @param {string} elmId
	 * @returns {Promise<void>}
	 */
	insertScriptHead(src, elmId) {
		return new Promise((resolve, reject) => {
			const scriptElm = this.createElement('script');
			scriptElm.type = 'text/javascript';
			scriptElm.async = true;
			scriptElm.id = elmId;
			scriptElm.src = src;
			this.window.document?.head.appendChild(scriptElm);
			scriptElm.onload = () => resolve();
			scriptElm.onerror = message => reject(message);
		});
	}

	/**
	 * @param {string} targetElm
	 * @param {Node} newElm
	 */
	appendChild(targetElm, newElm) {
		const target = this.getByTag(targetElm)[0];
		return target.appendChild(newElm);
	}

	/**
	 * @param {string} targetElm
	 * @param {Node} newElm
	 */
	insertBefore(targetElm, newElm) {
		const target = this.getByTag(targetElm)[0];
		target.parentNode.insertBefore(newElm, target);
	}

	/** @param {Node} elm */
	removeChild(elm) {
		return this.window.document.body.removeChild(elm);
	}

	viewportHeight() {
		return this.window.innerHeight;
	}

	/** @param {*} element jqLite element */
	appendToElm(element) {
		let parent = element;
		while (parent.length && !parent.hasClass('themed') && !parent.hasClass('body')) {
			parent = parent.parent();
		}
		return parent;
	}

	/**
	 * @param {Function} fn
	 * @param {number} delay
	 */
	debounce(fn, delay) {
		let timeoutId;
		return function (...args) {
			clearTimeout(timeoutId); // eslint-disable-line
			timeoutId = setTimeout(() => fn.apply(this, args), delay);
		};
	}
}
//
let svcMod = angular.module('mod.svc.DOMHelpersSvc', []).service('DOMHelpersSvc', DOMHelpers);
export default (svcMod = svcMod.name);
